// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

import { IJSONSchema } from '@glittr/frontend-core/src/plugins/validation/IJSONSchema';

const schema = {
  $id: '/update-articles-in-shop-category-request-schema',
  type: 'object',
  required: ['articleIds', 'id'],
  properties: {
    articleIds: {
      type: 'array',
      items: {
        type: 'integer',
      },
    },
    id: {
      type: 'integer',
    },
  },
} as IJSONSchema;

export default schema;
